import { render, staticRenderFns } from "./kv.vue?vue&type=template&id=0268225b&scoped=true"
import script from "./kv.vue?vue&type=script&lang=js"
export * from "./kv.vue?vue&type=script&lang=js"
import style0 from "./kv.vue?vue&type=style&index=0&id=0268225b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268225b",
  null
  
)

export default component.exports